import { DeclarationPropertyValueData } from "./declarationPropertyValueData";
import { DeclarationPropertiesTypes } from "./enums/declarationPropertiesTypes";
import { DeclarationPropertiesViews } from "./enums/declarationPropertiesViews";
import { Dictionary } from "./types/index";
import { ContractsFilters } from "./enums/contractsFilters";

/**Данные по декларации операции. */
export class DeclarationPropertyData {
  /**
   * Наимеменование.
   */
  public Name: string = "";

  /**
   * Заголовок.
   */
  public Caption: string = "";

  /**
   * Описание.
   */
  public Description: string = "";

  /**
   * Тип.
   */
  public Type: DeclarationPropertiesTypes = DeclarationPropertiesTypes.String;

  /**
   * Режимы отображения остатка.
   */
  public DisplayRestModes: number[];

  /**
   * Значение по умолчанию.
   */
  public Default: string = "";

  /**
   * Признак обязательности.
   */
  public Required: boolean = false;

  /**
   * Признак связанности поля.
   */
  public Assign: boolean = false;

  /**
   * Размер.
   */
  public Size: number = 0;

  /**
   * Маска поля.
   */
  public Mask: string = "";

  /**
   * Регулярное выражение для проверки.
   */
  public Check: string = "";

  /**
   * Сообщение при нарушении Check.
   */
  public CheckMsg: string = "";

  /**
   * Фильтр.
   */
  public Filter: number = 0;

  /**
   * Режим отображения.
   */
  public View: DeclarationPropertiesViews = DeclarationPropertiesViews.Editable;

  public SubProperties: Array<DeclarationPropertyData> = [];

  public SupPropertyDisplayName: string = '';

  /**
   * Тип списка: пока поддерживаются только значения пусто и 0.
   */
  public ListType: string = "";

  /**
   * Коллекция списка значений.
   */
  public Values: Dictionary<DeclarationPropertyValueData> = {};

  /**
   * Признак использования картинки в списках.
   */
  public Image: boolean = false;

  public imageSource: string | null = null;

  /**
   * Изображение действия.
   */
  public ActionImage: string = "";

  /**
   * Признак использования поиска.
   */
  public Find: boolean = false;

  /**
   * Строка, подставляемая в конец поля.
   */
  public Postfix: string = "";

  /**
   * Признак многострочного поля.
   */
  public Multiline: boolean = false;

  /**
   * Признак мультеселект поля.
   */
  public MultiSelect: boolean = false;
  
  /**
   * Лого-изображение.
   */
  public Logo: string = "";

  /**
   * Для сумм - привязка валюты к полю с именем.
   */
  public CurrencyFrom: string = "";

  /**
   * Конструктор с загрузкой данных.
   * @param src Источник данных.
   * @param  dPropsDescr Справочник описаний полей.
   */
  constructor(xn: Element, dPropsDescr: Dictionary<string>, isByCard: Boolean = false, isToExt: Boolean = false) {
    if (xn != null) {
      this.Name = xn.getAttribute("name") ?? "";

      this.Caption = xn.getAttribute("caption") ?? "";

      this.Default = xn.getAttribute("default") ?? "";

      this.Mask = xn.getAttribute("mask") ?? "";

      this.Description = dPropsDescr[this.Name] ?? "";

      let tmp = (xn.getAttribute("type") ?? "").toLowerCase();

      if (isByCard && this.Name == "card"){
        tmp = "cardselector";
      }
      this.ListType = xn.getAttribute("listType") ?? "";

      if(isToExt && this.Name == "bik" && this.ListType == "2")
        tmp = "bankbik";

      switch (tmp) {
        case "int":
        case "int32":
          this.Type = DeclarationPropertiesTypes.Int;
          break;
        case "decimal":
          this.Type = DeclarationPropertiesTypes.Decimal;
          break;
        case "boolean":
          this.Type = DeclarationPropertiesTypes.Boolean;
          break;
        case "datetime":
          this.Type = DeclarationPropertiesTypes.DateTime;
          break;
        case "useraccount":
          this.Type = DeclarationPropertiesTypes.UserAccount;
          break;
        case "action":
          this.Type = DeclarationPropertiesTypes.Action;
          break;
        case "contactphonetype":
        case "string":
          this.Type = DeclarationPropertiesTypes.String;
          break;
        case "cardselector": 
          this.Type = DeclarationPropertiesTypes.CardSelector;
          break;
        case "bankbik": 
          this.Type = DeclarationPropertiesTypes.BankBik;
          break;
        case "objectslist": 
          this.Type = DeclarationPropertiesTypes.ObjectsList;
          break;
        case "file":
          this.Type = DeclarationPropertiesTypes.File;
          break;
        default:
          this.Type = DeclarationPropertiesTypes.Unknown;
          break;
      }

      if (this.Type == DeclarationPropertiesTypes.ObjectsList)
      {
          const xpList = xn.getElementsByTagName("subproperty");
          this.SubProperties = [];
          for (let i = 0; i < xpList.length; i++)
          {
              let dpd = new DeclarationPropertyData(xpList[i], dPropsDescr, isByCard, isToExt);
              this.SubProperties.push(dpd);
          }
      }
      
      this.SupPropertyDisplayName = xn.getAttribute("displayName");

      tmp = (xn.getAttribute("required") ?? "").toLowerCase();
      this.Required = tmp == "1" || tmp == "true";

      tmp = (xn.getAttribute("assign") ?? "").toLowerCase();
      this.Assign = tmp == "1" || tmp == "true";

      tmp = (xn.getAttribute("multiline") ?? "").toLowerCase();
      this.Multiline = tmp == "1" || tmp == "true";

      tmp = (xn.getAttribute("multiSelect") ?? "").toLowerCase();
      this.MultiSelect = tmp == "1" || tmp == "true";

      tmp = xn.getAttribute("filter") ?? "";

      const filter = parseInt(tmp);
      this.Filter = isNaN(filter) ? ContractsFilters.All : filter;

      tmp = xn.getAttribute("size") ?? "";
      this.Size = parseInt(tmp);  
      if (isNaN(this.Size) || this.Type == DeclarationPropertiesTypes.Int) {
        this.Size =
          this.Type == DeclarationPropertiesTypes.Decimal
            ? 2 // Точность по умолчанию
            : this.Type == DeclarationPropertiesTypes.String
            ? 1000 // Максим. длина по умолчанию.
            : 0;
      }

      tmp = (xn.getAttribute("view") ?? "").trim();

      if (tmp == "2") this.View = DeclarationPropertiesViews.Hidden;
      else if (tmp == "1") this.View = DeclarationPropertiesViews.Readonly;
      else this.View = DeclarationPropertiesViews.Editable;

      tmp = (xn.getAttribute("image") ?? "").toLowerCase().trim();

      if (this.Type == DeclarationPropertiesTypes.Action)
        this.ActionImage = tmp ?? "";
      else this.Image = tmp == "true" || tmp == "1";

      const defaultImage = this.Image
        ? xn.getAttribute("defaultImage") ?? ""
        : "";
    

      if (this.ListType.trim() !== "") {
        const values = xn.getElementsByTagName("value");
        for (let i = 0; i < values.length; i++) {
          let image = this.Image ? values[i].getAttribute("image") ?? "" : "";
          if (this.Image && image.trim() == "" && defaultImage.trim() != "")
            image = defaultImage;

          const key = values[i].getAttribute("value") ?? "";
          this.Values[key] = new DeclarationPropertyValueData(
            key,
            values[i].getAttribute("caption") ?? "",
            image ?? "",
            null,
            '',
            i
          );
        }
      }

      tmp = (xn.getAttribute("find") ?? "").toLowerCase().trim();
      this.Find = tmp == "true" || tmp == "1";

      this.Logo = xn.getAttribute("logo") ?? "";

      this.Check = (xn.getAttribute("check") ?? "").trim();
      this.CheckMsg = (xn.getAttribute("checkMsg") ?? "").trim();

      this.CurrencyFrom = (xn.getAttribute("currencyFrom") ?? "").trim();

      this.Postfix = (xn.getAttribute("postfix") ?? "").trim();
    }
  }
}
